export const INDEX = '/:paramRegion?';

export const LIST = '/:type/otzyvy';
export const LIST_REGION = '/:type/otzyvy/:region';
export const ITEM = '/:type/:organization/otzyvy/:id';
export const ORGANIZATION_LIST = '/:type/:organization/otzyvy';
export const PRODUCT_LIST = '/:type/:organization/:product/otzyvy';
export const SPECIFIC_PRODUCT_LIST = '/:type/:organization/:product/otzyvy/:specificProduct';
export const CREATE_BASE = '/otzyvy/add';
export const CREATE_TYPE = '/:type/otzyvy/add';
export const CREATE_ORGANIZATION = '/:type/:organization/otzyvy/add';
export const CREATE_ORGANIZATION_PRODUCT = '/:type/:organization/:product/otzyvy/add';
export const EDIT = '/:type/:organization/otzyvy/:id/edit';

export const ORGANIZATION_LIST_MFO = '/:type/mfo/:organization/otzyvy';
export const PRODUCT_LIST_MFO = '/:type/mfo/:organization/:product/otzyvy';
export const SPECIFIC_PRODUCT_LIST_MFO = '/:type/mfo/:organization/:product/otzyvy/:specificProduct';
export const ITEM_MFO = '/:type/mfo/:organization/otzyvy/:id';
export const CREATE_MFO = '/:type/mfo/otzyvy/add';
export const CREATE_ORGANIZATION_MFO = '/:type/mfo/:organization/otzyvy/add';
export const EDIT_MFO = '/:type/mfo/:organization/otzyvy/:id/edit';

export const ITEM_OLD = '/:type/:organization/otzyv/:id';
export const EDIT_OLD = '/:type/:organization/otzyv/:id/edit';

export const LIST_MFO_OLD = '/mikrofinansovye-organizacii/otzyvy/';
export const ORGANIZATION_LIST_MFO_OLD = '/mikrofinansovaja-organizacija/:organization/otzyvy';
export const ORGANIZATION_LIST_MFO_SHORT = '/zaimy/:organization/otzyvy';
export const ITEM_MFO_OLD = '/mikrofinansovaja-organizacija/:organization/otzyv/:id';
export const ITEM_MFO_SHORT = '/zaimy/:organization/otzyv/:id';
export const CREATE_MFO_OLD = '/mikrofinansovaja-organizacija/otzyvy/add';
export const CREATE_ORGANIZATION_MFO_OLD = '/mikrofinansovaja-organizacija/:organization/otzyvy/add';

export const WRONG_SK_REVIEWS = '/insurancecompany/:organization/otzyvy';
export const CORRECT_SK_REVIEWS = '/strakhovaja-kompanija/:organization/otzyvy';
export const WRONG_SK_REVIEW = '/insurancecompany/:organization/otzyvy/:reviewId';
export const CORRECT_SK_REVIEW = '/strakhovaja-kompanija/:organization/otzyvy/:reviewId';

export const WRONG_MFO_REVIEW = '/mfo/:organization/otzyvy/:reviewId';
export const CORRECT_MFO_REVIEW = '/zaimy/mfo/:organization/otzyvy/:reviewId';

export const WRONG_BANK_REVIEW = '/bank/:organization/otzyv/:reviewId';
export const CORRECT_BANK_REVIEW = '/bank/:organization/otzyvy/:reviewId';

export const WIDGET = '/reviews/wl';
export const GOTO = '/goto/review/:id';

export const HEALTH_ROUTE = '/internal/health';
export const PING_ROUTE = '/internal/ping';

export const LIST_PATTERNS = [
  LIST,
  ORGANIZATION_LIST,
  ORGANIZATION_LIST_MFO,
  PRODUCT_LIST,
  PRODUCT_LIST_MFO,
  SPECIFIC_PRODUCT_LIST_MFO,
];
export const ITEM_PATTERNS = [ITEM, ITEM_MFO, GOTO];
export const CREATE_PATTERNS = [
  CREATE_BASE,
  CREATE_TYPE,
  CREATE_ORGANIZATION,
  CREATE_MFO,
  CREATE_ORGANIZATION_MFO,
  CREATE_ORGANIZATION_PRODUCT,
  EDIT,
  EDIT_MFO,
];

export const OLD_MFO_PATTERNS = [
  LIST_MFO_OLD,
  ORGANIZATION_LIST_MFO_OLD,
  ORGANIZATION_LIST_MFO_SHORT,
  ITEM_MFO_OLD,
  ITEM_MFO_SHORT,
  CREATE_MFO_OLD,
  CREATE_ORGANIZATION_MFO_OLD,
];

// TODO: сделать редиректы с сылок где type banki на bank то же самое СК
export const REDIRECTS: [string, string][] = [
  [WRONG_BANK_REVIEW, CORRECT_BANK_REVIEW],
  [WRONG_MFO_REVIEW, CORRECT_MFO_REVIEW],
  [WRONG_SK_REVIEWS, CORRECT_SK_REVIEWS],
  [WRONG_SK_REVIEW, CORRECT_SK_REVIEW],
  [LIST_MFO_OLD, LIST],
  [ORGANIZATION_LIST_MFO_OLD, ORGANIZATION_LIST_MFO],
  [ORGANIZATION_LIST_MFO_SHORT, ORGANIZATION_LIST_MFO],
  [ITEM_MFO_OLD, ITEM_MFO],
  [ITEM_MFO_SHORT, ITEM_MFO],
  [CREATE_MFO_OLD, CREATE_MFO],
  [CREATE_ORGANIZATION_MFO_OLD, CREATE_ORGANIZATION_MFO],
  [ITEM_OLD, ITEM],
  [EDIT_OLD, EDIT],
];

export const HEALTH_ROUTES = [HEALTH_ROUTE, PING_ROUTE];
